function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { Input, Label } from 'reactstrap';
import { _translate } from "../../services/core";
export default (function (_ref) {
  var type = _ref.type,
    onChange = _ref.onChange,
    label = _ref.label,
    errorMessage = _ref.errorMessage;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var handleOnChange = function handleOnChange(e) {
    if (e.target.value !== '') {
      setVisible(false);
    } else {
      setVisible(true);
    }
    onChange(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "input-material"
  }, /*#__PURE__*/React.createElement(Label, {
    className: isVisible ? '' : 'invisible hidden'
  }, _translate(label)), /*#__PURE__*/React.createElement(Input, {
    type: type,
    onChange: handleOnChange,
    className: errorMessage ? 'border-danger' : null
  }), errorMessage && /*#__PURE__*/React.createElement("span", {
    className: "message-input text-danger"
  }, _translate(errorMessage)));
});